import styled from 'styled-components';
import { Col as Cols } from 'react-styled-flexboxgrid';

const FilterListTop = styled('div')`
  @media (max-width: 1023px) {
    display: none;
  }
`;

const Holder = styled('div')`
  display: none;
  z-index: 500;
  @media (max-width: 1023px) {
    top: 65px;
    position: fixed;
    width: 100vw;
    left: 0;
    background-color: #fffffffb;
    display: block;
  }

  @media (max-width: 768px) {
    top: 45px;
  }
`;

const SideDrawerInner = styled('div')`
  padding: 50px 15px;
  overflow-y: auto;
  height: 100%;
`;

const Col = styled(Cols)`
  @media (max-width: 1023px) {
    .lg-show {
      display: none;
    }
  }
  @media (min-width: 1024px) {
    .md-hidden {
      display: none;
    }
  }
`;

const SearchWrapper = styled('div')`
  .header {
    background: #fff;
    padding: 20px;
    margin-bottom: 15px;
    min-height: 65px;
    @media (max-width: 1023px) {
      margin-top: 15px;
    }
  }
  .title {
    color: #19464f;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h1 {
      color: #0b2f3f;
      font-family: Poppins;
      font-size: 20px;
      font-weight: 600;
      margin: 0;
    }
    .save-search {
      border: 1px solid rgba(11, 47, 63, 0.2);
      border-radius: 4px;
      font-family: Poppins;
      font-weight: 500;
      padding: 15px 20px;
      cursor: pointer;
      background-color: #fff;
      transition: all 0.2s;
      i,
      span {
        transition: all 0.2s;
      }
      &:hover {
        border-color: #00bcd4;
        span,
        i {
          color: #00bcd4;
        }
      }
      span {
        color: #0b2f3f;
      }
      &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }
    }
  }
  .filter {
    padding-top: 1rem;
  }
  .filterCheckbox {
    margin-left: 1rem;
  }
`;

export { Holder, Col, SideDrawerInner, FilterListTop, SearchWrapper };
